var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.open}},[_vm._v("Abrir")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }